import Debug from "debug";
import * as React from "react";
import { DynamicText } from "../ancillary/DynamicText";
import { Field, FieldType, getDisplayTextFromPrimitive, TextField } from "gossamer-unified";
import styles from "./Uneditable.module.css";

const debug = Debug("gfe/fi/Uneditable");

interface UneditableProps {
  className?: string;
  field: Field;
  value: string;
}

export const Uneditable: React.FC<UneditableProps> = (props) => {
  let display = getDisplayTextFromPrimitive(props.field, props.value);
  const inner =
    props.field.type === FieldType.Text && (props.field as TextField).isDynamic ? (
      <DynamicText text={display} />
    ) : (
      display
    );

  // debug(`${props.field.label}: ${props.value} -> ${display}`);
  const className = styles.RowCell + (props.className ? " " + props.className : "");
  return <div className={className}>{inner}</div>;
};
